import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from "../interfaces/app-config.model";
import { Configuracao } from '../models/configuracao';
import { globals } from 'src/app/globals';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: IAppConfig = {
    api: {
      url: []
    },
    defaultPageTitle: '',
    idVisual: {
      urlLogo: '',
      urlLogoMenu: '',
      urlLogoMini: '',
      urlBackground: '',
      corPrincipal: '',
      corSecundaria: '',
      usarCorSecundariaNosBotoes: false
    },
    cacheTime: 1000 * 60,
    captchaClientKey: null,
  };

  constructor(private http: HttpClient) { }

  async loadAppConfig() {
    return this.http
      .get('assets/config/config.json')
      .toPromise()
      .then(async (data: IAppConfig) => {
        this.appConfig = data;

        await this.getIdentidadeVisual();
      });
  }

  getServerUrls(): string[] {
    return this.appConfig.api.url;
  }

  getTemplates(): Configuracao[] {
    return globals.configuracoes;
  }

  getDefaultPageTitle(): string | null {
    return this.appConfig.defaultPageTitle;
  }

  getCacheTime(): number {
    return this.appConfig.cacheTime;
  }

  public getCaptchaSiteKey(): string | null {
    return this.appConfig.captchaClientKey;
  }

  async getIdentidadeVisual() {
    const url = globals.apiUrl || this.appConfig.api.url[0];

    return this.http
      .get<any>(`${url}/api/IdentidadeVisual`)
      .toPromise()
      .then(idVisual => {
        this.appConfig.idVisual = idVisual;
        localStorage.setItem('idVisual', JSON.stringify(idVisual));
      })
      .catch(error => {
        //console.error('Erro ao carregar identidade visual:', error);
      });
  }
}
